import { render } from "./DonationsGrid.vue?vue&type=template&id=d1003a3c&scoped=true"
import script from "./DonationsGrid.vue?vue&type=script&lang=js"
export * from "./DonationsGrid.vue?vue&type=script&lang=js"

import "./DonationsGrid.vue?vue&type=style&index=0&id=d1003a3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1003a3c"

export default script